import React from 'react';
import { Button, Divider, List } from 'antd';
import Drawer from 'components/Drawer';
import useCustomer from 'hooks/useCustomer';
import useUser from 'hooks/useUser';
import { EDIT_CUSTOMER_DASHBOARD, VIEW_DASHBOARDS } from 'shared/constants/permissions';

const extraFields = `
  dashboardPages { 
    id 
    title
    user { id } 
    dashboards { id title } 
  }
  reports { id title dashboard { id } }
`;

const AddToDashboardDrawer = ({ open, onSubmit, onCancel, currentDashboardId }) => {
  const { customer, loading, hasCustomerPermission } = useCustomer({ extraFields });
  const { user, hasPermission } = useUser();

  const reports = customer?.reports.filter(r => r.dashboard && r.dashboard?.id !== currentDashboardId);
  const userDashboardPage = customer?.dashboardPages?.find(d => d.user?.id === user?.id);
  const customerDashboardPage = customer?.dashboardPages?.find(d => !d.user);

  return (
    <Drawer
      open={open}
      onCancel={onCancel}
      title="Add to dashboard"
      loading={loading}
    >
      <p>Select a dashboard to copy the content to.</p>
      <h3>Reports</h3>
      {reports?.length > 0 ? (
        <List
          dataSource={reports}
          renderItem={(report) => (
            <List.Item actions={[<Button onClick={() => onSubmit(report.dashboard.id)}>Add</Button>]}>
              <List.Item.Meta
                title={report.title}
              />
            </List.Item>
          )}
        />
      ) : <em>No reports found</em>}

      {hasCustomerPermission(EDIT_CUSTOMER_DASHBOARD) && (
        <>
          <Divider />
          <h3>Account Dashboards</h3>
          {customerDashboardPage?.dashboards?.length > 0 ? (
            <List
              dataSource={customerDashboardPage?.dashboards}
              renderItem={(dashboard) => (
                <List.Item actions={[<Button onClick={() => onSubmit(dashboard.id)}>Add</Button>]}>
                  <List.Item.Meta
                    title={dashboard.title}
                  />
                </List.Item>
              )}
            />
          ) : <em>No account dashboards found</em>}
        </>
      )}

      {hasPermission(VIEW_DASHBOARDS) && (
        <>
          <Divider />
          <h3>Personal Dashboards</h3>
          {userDashboardPage?.dashboards?.length > 0 ? (
            <List
              dataSource={userDashboardPage?.dashboards}
              renderItem={(dashboard) => (
                <List.Item actions={[<Button onClick={() => onSubmit(dashboard.id)}>Add</Button>]}>
                  <List.Item.Meta
                    title={dashboard.title}
                  />
                </List.Item>
              )}
            />
          ) : <em>No personal dashboards found</em>}
        </>
      )}
    </Drawer>
  );
};

export default AddToDashboardDrawer;
